var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"edge edge-left"}),_c('div',{staticClass:"contained"},[_vm._t("default")],2),_c('div',{staticClass:"edge edge-right"})])}
var staticRenderFns = []

export { render, staticRenderFns }